import React from 'react';
import NoItems from '../../assets/no-items-yet.png';
// import NoReq from '../../assets/no-requirements-yet.png';
import { InlineNotification } from 'carbon-components-react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  title: {
    fontFamily: 'Helvetica',
    fontSize: 20,
    color: '#171717',
    lineHeight: '26px'
  },
  subtitle: {
    fontFamily: 'Helvetica',
    fontSize: 14,
    color: '#565656',
    letterSpacing: 0.16,
    lineHeight: '18px'
  },
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  img: {
    padding: '85px 0 56px 0',
    textAlign: 'center'
  },
  titleInfo: {
    fontFamily: 'Roboto-Regular',
    fontSize: 20,
    color: '#172B4D',
    textAlign: 'center',
    lineHeight: '24px'
  },
  textInfo: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,
    color: '#172B4D',
    textAlign: 'center',
    lineHeight: '20px',
    padding: '16px 0 24px 0'
  },
  table: {
    minWidth: 650
  }
}));

const NotFound = ({
  title,
  subtitle,
  handleOpen,
  notification,
  message,
  type
}) => {
  const classes = useStyles();
  // const src = type === 'no-req' ? NoReq : NoItems;

  return (
    <div className={classes.root}>
      <div style={{ paddingTop: 54 }}>
        <h2 className={classes.title}>{title}</h2>
        <p>{subtitle}</p>
      </div>
      <div className={classes.content}>
        {notification && (
          <div className='data-table_notification'>
            <InlineNotification
              iconDescription='Cerrar notificación'
              kind={notification.type}
              lowContrast
              title={notification.message}
            />
          </div>
        )}
        <div className={classes.img}>
          <img src={NoItems} alt='Figure - No items yet' width='65%' />
        </div>
        <div className={classes.content}>
          <p className={classes.titleInfo}>No items yet</p>
          <p className={classes.textInfo}>{message}</p>
          <div>
            <button
              className='bx--btn bx--btn--primary'
              type='button'
              onClick={handleOpen}
            >
              Add item
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
